<template>
    <div class="m-portlet m-portlet--head-sm" :class="{'m-portlet--collapse' : !isOpen }"  m-portlet="true" id="m_portlet_tools_4">
        <div class="m-portlet__head preview">
            <div class="m-portlet__head-caption">
                <div class="m-portlet__head-title">
                    <h3 class="m-portlet__head-text">{{ labels.title_product_formula }}</h3>
                </div>
            </div>
        </div>
        <div class="m-portlet__body" m-hidden-height="345" :style="bodyStyle">
            <div class="custom_scroll_long larger-text">
                <p><span class="text_bolder">{{ labels.resources.textures }} : </span> <span v-html="fieldValue('textureName')"></span></p>
                <p><span class="text_bolder">{{ labels.resources.texturotheques }} : </span> <span v-html="fieldValue('texturothequeName')"></span></p>
                <p><span class="text_bolder">{{ labels.tinted }} : </span> {{ displayYesNo(previewProduct.tinted) }}</p>
                <p><span class="text_bolder">{{ labels.title_spf}} : </span><span v-html="fieldValue('spf')"></span></p>
                <p><span class="text_bolder">{{ labels.title_uva }} : </span><span v-html="fieldValue('uva')"></span></p>
                <p><span class="text_bolder">{{ labels.perfume }} : </span> {{ displayYesNo(previewProduct.perfume) }}</p>
                <p><span class="text_bolder">{{ labels.perfume_claimed }} : </span> {{ displayYesNo(previewProduct.perfumeClaimed) }}</p>
                <p><span class="text_bolder">{{ labels.bio }} :</span> {{ displayYesNo(previewProduct.bio) }}</p>
                <p><span class="text_bolder">{{ labels.list_inci }} : </span><span style="white-space: pre-line" v-html="fieldValue('listINCI')"></span></p>
                <p><span class="text_bolder">{{ labels.manual }} : </span> <span style="white-space: pre-line" v-html="fieldValue('manual')"></span></p>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    props: ['previewProduct', 'compareMode'],
    data () {
        return {
            isOpen: true
        }
    },
    filters: {
        transformDecimal: function (value) {
            if (value !== undefined) {
                var stringed = value.toString()
                return stringed.replace('.', ',')
            }
            return ''
        }
    },
    computed: {
        ...mapState({
            labels: state => state.labels
        }),
        bodyStyle () {
            if (!this.isOpen) {
                return 'display: none; overflow: hidden; padding-top: 0px; padding-bottom: 0px;'
            }
            return ''
        }
    },
    methods: {
        displayArray (array) {
            return array.join(', ')
        },
        togglePortlet () {
            this.isOpen = !this.isOpen
        },
        displayYesNo (value) {
            return value ? this.labels.yes : this.labels.no
        },
        fieldValue (field) {
            var value = this.previewProduct._highlightResult[field] ? this.previewProduct._highlightResult[field].value : this.previewProduct[field]
            if (value && Array.isArray(value)) {
                return value.join(', ')
            } else if (isNaN(value) && Date.parse(value) && parseInt(value)) {
                return this.displayDate(value)
            } else if (value) {
                return value
            } else {
                return field === 'spf' || field === 'uva' ? this.labels.no : ''
            }
        },
        displayDate (dateStr) {
            var date = new Date(dateStr)
            return date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear()
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Products/Preview/FurtherInfo.vue